import { Form, InputNumber } from 'antd'
import { FC } from 'react'
import { requiredInputNumberRules } from '../../../../../../../../../../constants/forms/validation/rules'

interface RadiusProps {}

const Radius: FC<RadiusProps> = () => {
    const name = 'radius'
    return (
        <Form.Item name={name} label={'Радиус'} rules={requiredInputNumberRules}>
            <InputNumber />
        </Form.Item>
    )
}

export default Radius
